import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../components/Header';

const OutletDashboard = () => {

    const navigate = useNavigate()

    return (
        <div className='bg-brand'>
            <div className="container">
                <h1 className='pt-3 text-center fw-bold'><span className='fs-4 d-none d-lg-block'>Vendor Manage Inventory Transparency</span><span className='fs-6 d-lg-none'>Vendor Manage Inventory Transparency</span></h1>

                <Header />

                <div className="d-flex justify-content-center align-items-center mt-3">
                    <div onClick={() => navigate('/list-upload')} style={{ height: "100px", width: "200px", backgroundColor: '#9DC08B', fontSize:'14px', cursor:'pointer' }} className="col-sm-5 p-3 rounded mx-3 d-flex justify-content-center align-items-center">
                        <Link to='/list-upload' className='text-decoration-none text-black text-center'>List Upload</Link>
                    </div>

                    <div onClick={() => navigate('/previous-uploaded-list')} style={{ height: "100px", width: "200px", backgroundColor: '#3A98B9', fontSize:'14px', cursor:'pointer' }} className="col-sm-5 p-3 rounded mx-3 d-flex justify-content-center align-items-center">
                        <Link to='/previous-uploaded-list' className='text-decoration-none text-black text-center'>Previous Uploaded List</Link>
                    </div>
                </div>

                {/* <button onClick={() => navigate('/list-upload')} className='btn-action mx-auto d-block mt-5 w-75'>Go to List Upload</button>
                <button onClick={() => navigate('/previous-uploaded-list')} className='btn-action mx-auto d-block mt-5 w-75'>Previous Uploaded List</button> */}
            </div>
        </div>
    );
};

export default OutletDashboard;